"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalActions = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _modalTheme = require("./modalTheme");
const StyledModalActions = (0, _styled.default)("div")(_ref => {
  let {
    themeMode
  } = _ref;
  return `
    padding: ${_modalTheme.modalTheme.actionsPadding(themeMode)}};
    display: inline-flex;
    align-items: center;
    gap: ${_spacing.sizes.xSmall}px;
`;
});
exports.StyledModalActions = StyledModalActions;
//# sourceMappingURL=Actions.js.map